import(/* webpackMode: "eager", webpackExports: ["IntegrationsGrid"] */ "/tmp/8de698b5c6a30cb/components/sections/IntegrationsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/node_modules/next/dist/client/link.js");
